<template lang="pug">
.dropdown-wrapper
  .dropdown(:class="`${disabled ? 'disabled' : ''} ${error ? 'has-error' : ''} ${icon ? 'has-icon' : ''} ${search ? 'has-search' : ''}`", @keyup.tab.prevent="majs", @blur="majsa")
    .inner(@click="drop")
      .icon(v-if="icon")
        i.mdi(:class="`mdi-${icon}`")
      .selected(:class="`${multiple ? 'multiple' : ''}`")
        template(v-if="!multiple && selected")
          span {{ selected.string }}
        template(v-else-if="multiple && selected.length > 0")
          span(v-for="(item, index) in selected", :key="item.value") {{ item.string }}{{ index < selected.length - 1 ? ', ' : ''}}
        template(v-else)
          span.placeholder {{ placeholder }}
      .down: i.mdi.mdi-menu-down(:class="`${dropped ? 'mdi-rotate-180' : ''}`")
    .dropper(v-if="dropped" v-click-outside="clickedOutsideDropper", :class="`${maxHeight ? 'dropper--has-maxheight' : ''} ${direction}`" :style="`max-height: ${maxHeight}px;`")
      FormInput(v-if="search", :value="searchString", @input="$emit('search', $event)" @focus="majs")
      .no-items(v-if="listItems.length === 0") No items
      ul.dropper-list
        li(v-for="(item, index) in listItems", :key="index", :class="`${item.selected ? 'selected' : ''} ${item.disabled ? 'disabled' : ''}`", @click="item.disabled ? null : emit(index, item.value)", tabindex="0", @keyup.enter.stop="emit(index, item.value)", @focus="majs", @blur="majsa")
          p {{ item.string }}
          small(v-if="item.description" v-html="item.description")
  p.error(v-if="error") {{ error }}
</template>

<script>

import FormInput from './Input.vue';

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    icon: {
      type: String,
      default: '',
    },
    value: {
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Choose something',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxHeight: {
      type: Number,
      default: null,
    },
    search: {
      type: Boolean,
      default: false,
    },
    searchString: {
      type: String,
      default: '',
    },
    forceUp: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
  },
  components: {
    FormInput,
  },
  computed: {
    listItems() {
      const { items, value } = this;
      if (!value || value === '' || value === null) {
        return items;
      }

      return items.map(item => ({ ...item, selected: item.value === value }));
    },
    /**
     * Return the selected items in the items array
     * @return {?Object|Array}
     */
    selected() {
      const { listItems, multiple } = this;

      if (!listItems) {
        return null;
      }

      const selected = listItems.filter(item => item.selected);
      if (selected.length > 0) {
        return multiple ? selected : selected[0];
      }

      return multiple ? [] : null;
    },
  },
  methods: {
    majsa() {
      if (this.dropped) {
        this.blurTimeout = setTimeout(() => {
          this.dropped = false;
        }, 250);
      }
    },
    majs() {
      this.dropped = true;
      clearTimeout(this.blurTimeout);
    },
    /**
     * Toggle the dropdown
     */
    drop() {
      if (this.disabled) {
        return;
      }

      const dropped = !this.dropped;

      this.$emit('dropped', dropped);

      setTimeout(() => {
        this.$emit('dropped', false);
      }, 100);

      if (dropped) {
        // We need a little timeout so the clickedOutsideDropper-function
        // is not run immediatly
        setTimeout(() => {
          this.dropped = dropped;
          this.$nextTick(() => {
            if (this.search) {
              try {
                this.$el.querySelector('input').focus();
                this.$el.querySelector('input').select();
              } catch (e) { /* Do nothing */ }
            }
          });
        }, 50);

        const rect = this.$el.getBoundingClientRect();
        this.direction = window.innerHeight - rect.top > 300 && !this.forceUp ? 'down' : 'up';
      }
      clearTimeout(this.blurTimeout);
    },
    /**
     * Hide the dropper and emit that we click outside
     */
    clickedOutsideDropper() {
      this.dropped = false;
      this.$emit('clickedOutside', true);
    },
    /**
     * Emit choosen one to parent
     * @param {Number} index
     * @param {String|Boolean} value
     */
    emit(index, value) {
      this.$emit('dropped', true);

      setTimeout(() => {
        this.$emit('dropped', false);
      }, 100);

      this.$emit('input', { index, value });
      this.dropped = false;
    },
  },
  data() {
    return {
      blurTimeout: null,
      dropped: false,
      direction: 'down',
    };
  },
  beforeDestroy() {
    clearTimeout(this.blurTimeout);
  },
};
</script>

<style lang="scss">
.dropdown {
  &.has-search {
    .input {
      border-left: 0;
      border-right: 0;

      &:focus {
        outline: 1;
      }
    }
  }
  .dropper {
    li {
      &:hover, &.selected {
        small {
          .link.blue {
            color: white;
          }
        }
      }
    }
  }
}

.input-dropdown {
  display: flex;
  .dropdown {
    border-left: 0 !important;

    .inner {
      .down {
        border-left: 0;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.dropdown-input {
  .dropdown {
    border: 0;
    .inner {
      .down {
        border-left: 0;
        border-radius: 0;
      }
    }
  }
}

.error {
  font-style: italic;
  font-size: 13px;
  line-height: 18px;
  margin-top: 2px;
  color: #FF1717;
}

.dropdown {
  background: #FFFFFF;
  border: 1px solid #D7D9E0;
  box-shadow: inset 0 1px 2px 0 rgba(0,0,0,0.10);
  position: relative;

  &.has-error {
    background: #FFF1F0;
    border: 1px solid #FF4848;
    box-shadow: inset 0 1px 2px 0 rgba(0,0,0,0.10);
    .inner {
      .down {
        background: #FFF1F0;
        color: #FF1717;
      }
    }
  }

  &.disabled {
    .inner {
      opacity: .5;

      &:hover {
        cursor: not-allowed;
      }
    }
  }

  .icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    padding-left: 10px;
    i {
      font-size: 24px;
    }
  }

  &.has-icon {
    .inner {
      .selected {
        padding-left: 40px;
      }
    }
  }

  .inner {
    min-height: 48px;

    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-tap-highlight-color: transparent;

    &:hover {
      cursor: pointer;
    }

    .selected {
      font-weight: 400;
      font-size: 16px;
      padding: 0 10px;
      width: 100%;
      padding-right: 40px;
      line-height: 48px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      .placeholder {
        color: gray;
      }
    }

    .down {
      align-items: center;
      justify-content: center;
      border-left: 1px solid #E9EBED;
      display: flex;
      width: 30px;
      color: #0360FF;
      font-size: 30px;
      position: absolute;
      right: 0;
      bottom: 2px;
      top: 0;
      background-color: white;

      i:before {
        transition: transform .3s;
      }
    }
  }

  .dropper {
    background-color: white;
    border: 1px solid #B7BDC6;
    box-shadow: 2px 2px 0 #CED4DE;
    display: flex;
    flex-direction: column;
    position: absolute;
    z-index: 100;
    min-width: 100%;
    overflow: hidden;
    max-width: 180px;
    max-height: 250px;
    overflow: auto;
    transform: translateX(-50%);
    left: 50%;

    &.down {
      top: calc(100% + 1px);
    }

    &.up {
      bottom: calc(100% + 1px);
    }

    &.dropper--has-maxheight {
      .dropper-list {
        flex: 1;
        overflow: auto;
      }
    }

    .no-items {
      padding: 10px;
      color: rgba(0, 0, 0, .5);
    }

    li {
      padding: 10px;
      overflow: hidden;
      text-overflow: ellipsis;

      &:hover {
        background-color: #0360FF;
        cursor: pointer;
        color: white;

        small {
          color: white;
          .link.blue {
            color: white !important;
          }
        }
      }

      &.disabled {
        opacity: .5;
      }

      &.selected {
        background-color: #EFF6FF;
        color: black;
        small {
          color: rgba(44, 62, 79, 0.5);
          .link.blue {
            color: white;
          }
        }
      }
    }
  }

  &.site-style {
    border: 2px solid #B7C7E7;
    border-radius: 12px;
    padding-bottom: 0;

    &.semi {
      border-radius: 4px;
      border-color: #E5E9EC;

      .inner {
        border-radius: 4px;

        .down {
          border-radius: 0 4px 4px 0;
        }
      }
    }

    .icon {
      color: #B7C7E7;
      padding-left: 15px;
      i {
        font-size: 1.8rem;
      }
    }

    .dropper {
      max-height: 230px;
      overflow: auto;
    }

    &.error {
      border-color: #C11B1B;
      &:after {
        content: none;
      }
      .down i {
        color: #C11B1B;
      }
    }

    &.has-icon {
      .inner {
        .selected {
          padding-left: 55px;
        }
      }
    }

    .inner {
      background-color: #FBFCFE;
      border-radius: 12px;

      .selected {
        line-height: 48px;
      }

      .down {
        bottom: 0;
        border: 0;
        background-color: transparent;
        border-radius: 0 12px 12px 0;
        right: 10px;

        i {
          font-size: 2.5rem;
        }
      }
    }

    span {
      font-size: 16px;
      &.placeholder {
        color: #a0aec0;
      }
    }
  }

  &.inline {
    display: inline-block;
  }

  &.blue {
    color: #0360FF;
  }
}

.dropdown-wrapper {
  &.minimal {
    .dropdown {
      background-color: transparent;
      box-shadow: none;
      border: 0;
      border-radius: 0;
      padding: 0;
    }

    .inner {
      border-radius: 0;
      min-height: auto;

      .selected {
        line-height: 24px;
        padding: 0 25px 0 3px;
        font-size: 12px;
        font-weight: 600;
      }

      .down {
        border-left: 0;
        width: 20px;
      }
    }

    .dropper {
      li {
        font-size: 12px;
        padding: 6px 10px;
      }
    }
  }
}
</style>
